import gql from 'graphql-tag';
import FieldsTimeslotGroup from "graphql/fields/FieldsTimeslotGroup";

export default gql(`
	query timeslot_groups( $active: String ) {
		timeslot_groups( active: $active ) {
			${FieldsTimeslotGroup}
		}
	}
`);